import { useMutation } from "react-query";
import api from "../../client";
import { Interaction } from "../../types/interaction";

const deleteData = async (id: string | undefined): Promise<Interaction> => {
  const { data } = await api.delete(`/interactions/${id}`);

  return data;
};

export const useDeleteInteraction = () => {
  return useMutation((id: string | undefined) => {
    return deleteData(id);
  });
};
